import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import faqData from "./faqData";

//styles
import "./FAQScreen.scss";

//libraries
import { TfiEmail } from "react-icons/tfi";

const FAQScreen = () => {
  const sendEmail = () => {
    window.location.href = "mailto:christian@conciergewellnessandpt.com";
  };
  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | Concierge Wellness</title>

        <meta
          name="description"
          content="Find answers to common questions about physical therapy, massage therapy, scheduling, insurance, telehealth, and concierge care at Concierge Wellness in Colorado Springs."
        />

        <link rel="canonical" href="https://conciergewellnesspt.com/faq" />

        <meta
          property="og:title"
          content="Frequently Asked Questions | Concierge Wellness"
        />

        <meta
          property="og:description"
          content="Learn more about our physical therapy and massage therapy services, appointment process, telehealth options, and concierge care model."
        />

        <meta property="og:url" content="https://conciergewellnesspt.com/faq" />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>
      <main className="faq">
        <div className="faq-title" data-aos="fade-up" data-aos-duration="1000">
          <h1>FAQs</h1>
          <span className="hr-line"></span>
        </div>
        <div
          className="faq-container"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {faqData.map((faq, index) => (
            <div className="faq-text" key={index}>
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
        <div className="faq-questions-container">
          <div className="faq-content">
            <div className="icon-container">
              <TfiEmail className="icon" />
            </div>
            <p>
              <span className="bold">
                Still don't have the answers you're looking for?
              </span>{" "}
              Submit a question on our <Link to="/contact">Contact</Link> page,
              or email Concierge Wellness at
              christian@conciergewellnessandpt.com
            </p>
          </div>
        </div>
        <div className="show" onClick={sendEmail}>
          <TfiEmail className="icon" />
        </div>
      </main>
    </>
  );
};

export default FAQScreen;
